import { useCallback } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
import { fetchConditionalPropertyRules } from '../conditionalPropertyRules/api';
export const useConditionalPropertyRulesForObjectType = (objectTypeId, options = {
  skip: false
}, includeAssociationFields = false) => {
  const httpClient = useHttpClient();
  const getRules = useCallback(() => {
    return fetchConditionalPropertyRules(objectTypeId, httpClient, {
      includeAssociationFields
    });
  }, [httpClient, objectTypeId, includeAssociationFields]);
  return useAsyncFunction(getRules, options);
};